// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gZdm","col":"styles_col__SlRxK"};